export default "__VITE_ASSET__5b8aa9fe__"